import { useMutation, useQueryClient } from "@tanstack/react-query"
import api from "~/api2"
import { OrderPreviewParams } from "~/api2/orders"
import IOrder from "~/interfaces/IOrder"
import IOrderPreview from "~/interfaces/IOrderPreview"
import IInvoice from "~/interfaces/IInvoice"

interface CreateOrderPreviewResponse {
  order: { preview: IOrderPreview } & { invoice?: IInvoice }
}

export const useCreateOrderPreview = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: OrderPreviewParams): Promise<CreateOrderPreviewResponse> => {
      return api.Orders.createPreview(params)
    },

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["order", variables.order_id] })

      queryClient.setQueryData(["orderPreview", variables.order_id], data.order.preview)

      return data.order.preview
    },
  })
}
